import { TextInput } from 'components'
import { IconClose, IconSearch } from 'components/Icons'
import { onEnter } from 'helpers/common'
import { IParam } from 'libs/apis'
import React, { KeyboardEvent, MouseEvent, useRef } from 'react'
import { useTranslation } from 'react-i18next'

interface CreateTicketSearchSectionProps {
  baseClass: string
  debouncedSearch: (value: string) => void
  searchParams: IParam
  setSearchParams: (searchParams: IParam) => void
}

export const CreateTicketSearchSection: React.FC<CreateTicketSearchSectionProps> =
  ({ baseClass, searchParams, setSearchParams, debouncedSearch }) => {
    const { t } = useTranslation(['ticket'])
    const searchParamsRef = useRef('')

    const handleSearchChange = (
      e: React.ChangeEvent<HTMLInputElement>,
    ): void => {
      e.preventDefault()
      searchParamsRef.current = e.target.value
      setSearchParams({ ...searchParams, q: e.target.value })
      debouncedSearch(e.target.value)
    }

    const handleSearchSubmit = (
      e: KeyboardEvent<HTMLInputElement> | MouseEvent<HTMLSpanElement>,
    ): void => {
      e.preventDefault()
      searchParamsRef.current = searchParams.q || ''
      setSearchParams({ ...searchParams, q: searchParams.q || '' })
      debouncedSearch(searchParams.q || '')
    }

    const handleClearSearch = (): void => {
      searchParamsRef.current = ''
      setSearchParams({ ...searchParams, q: '' })
      debouncedSearch('')
    }

    return (
      <div className={`${baseClass}__input-search-product`}>
        <TextInput
          fullWidth
          placeholder={t('ticket:searchBranch.placeholder')}
          name='search'
          onChange={handleSearchChange}
          value={searchParamsRef.current}
          onKeyDown={onEnter(handleSearchSubmit)}
          withIcon={
            searchParams.q ? (
              <span className={`${baseClass}__in-line-btn`}>
                <IconClose variants='sm' onClick={handleClearSearch} />
              </span>
            ) : (
              <span className={`${baseClass}__in-line-btn`}>
                <IconSearch variants='sm' onClick={handleSearchSubmit} />
              </span>
            )
          }
        />
      </div>
    )
  }
